import * as mdb from 'mdb-ui-kit'; // lib
// import LazyLoad from 'vanilla-lazyload';

// Utilities
export const importAll = (r) => r.keys().forEach(r);

// Generate url
export const reverseUrl = (urlName, kargs = {}) => {
  let url = window.routes[urlName];
  if (!url) {
    console.error(`URL '${urlName}' was not found.`)
    return null;
  }
  Object.keys(kargs).forEach((key) => {
    const value = kargs[key]
    if (typeof value === 'undefined' || value === '') {
      console.error(`Invalid URL lookup: URL '${url}'. Argument '${key}' was not provided.`)
      return null;
    }
    url = url.replace(new RegExp(`<${key}>`), value)
  })
  return url;
}

// The "lazyLazy" instance of lazyload is used to check
// when the .horizContainer divs enter the viewport
// document.querySelectorAll('.lazyload').forEach((e) => {
//   const lazyLoad = new LazyLoad({}, e)
// })
